import _ from "lodash";
import settings from "../../settings";
import { getNodeValue } from "./Utils";

export const getDate = (node) => {
  if (node === undefined) {
    return "";
  }
  const day = _.get(node, "day[0]._", "");
  const month = _.get(node, "month[0]._", "");
  const year = _.get(node, "year[0]._", "");
  if (day !== "") {
    return `${month}/${day}/${year}`;
  }
  if (month !== "") {
    return `${month}/${year}`;
  }
  if (year !== "") {
    return `${year}`;
  }
  const date = _.get(node, "_", "");
  if (date !== "") {
    return date;
  }
  return _.get(node, "_", "");
};

export const getMonthAndYear = (node) => {
  if (node === undefined) {
    return "";
  }
  const month = getNodeValue(node, "month");
  const year = getNodeValue(node, "year");
  if (year && year !== "") {
    if (month && month !== "") return `${month}/${year}`;
    return `${year}`;
  }
  return _.get(node, "._", "");
};

export const getMonthAndYearRaw = (node) => {
  if (node === undefined) {
    return "";
  }
  const month = getNodeValue(node, "month");
  const year = getNodeValue(node, "year");
  if (year && year !== "") {
    if (month && month !== "") {
      const intMonth = parseInt(getNodeValue(node, "month"), 10);
      return `${year}${intMonth <= 9 ? "0" : ""}${intMonth}`;
    }
    return `${year}`;
  }
  return _.get(node, "._", "");
};

export const getDobDate = (dob, props) => {
  let dobStr = _.get(dob, "_", "");
  if (props && props.isDobValue) {
    dobStr = dob;
  }
  if (!(dob || dobStr !== "")) {
    return "N/A";
  }

  let dobDay = _.get(dob, "day[0]._", "");
  let dobMonth = _.get(dob, "month[0]._", "");
  let dobYear = _.get(dob, "year[0]._", "");
  let tokens = [];
  if (dobStr !== "") {
    tokens = dobStr.split("/");
  }
  if (tokens.length === 1) {
    if (dobYear === "") {
      dobYear = tokens[0];
    }
  } else {
    if (dobDay === "" && tokens.length > 1) {
      dobDay = tokens[1];
    }
    if (dobMonth === "" && tokens.length > 0) {
      dobMonth = tokens[0];
    }
    if (dobYear === "" && tokens.length > 2) {
      dobYear = tokens[2];
    }
  }
  if (dobStr.startsWith("09/01") || dobStr.startsWith("9/1/")) {
    return dobYear;
  }
  if (dobDay === "" && dobMonth === "" && dobYear === "") return "N/A";
  if (props.userAccount.btType === "3") {
    if (dobYear !== "") {
      if (dobMonth !== "") {
        return `${dobMonth}/${dobYear}`;
      }
      return dobYear;
    }
    return "N/A";
  }

  if (props.userAccount.btType === "1" || props.userAccount.btType === "2") {
    if (
      dobDay !== "" &&
      props.userAccount.mastDOBMask === settings.dobMask.ShowAll
    ) {
      return `${dobMonth}/${dobDay}/${dobYear}`;
    }
    if (
      dobMonth !== "" &&
      (props.userAccount.mastDOBMask === settings.dobMask.ShowAll ||
        props.userAccount.mastDOBMask === settings.dobMask.ShowMonthYear)
    ) {
      if (dobDay !== "") return `${dobMonth}/XX/${dobYear}`;
      return `${dobMonth}/${dobYear}`;
    }
    if (
      dobYear !== "" &&
      (props.userAccount.mastDOBMask === settings.dobMask.ShowAll ||
        props.userAccount.mastDOBMask === settings.dobMask.ShowMonthYear ||
        props.userAccount.mastDOBMask === settings.dobMask.ShowYearOnly)
    ) {
      if (dobDay !== "" && dobMonth !== "") return `XX/XX/${dobYear}`;
      if (dobMonth !== "") return `XX/${dobYear}`;
      return dobYear;
    }
  }
  return "XX/XX/XXXX";
};

export const getDodDate = (dod, props) => {
  const dodStr = _.get(dod, "_", "");
  if (!(dod || dodStr !== "")) {
    return "N/A";
  }

  let dodDay = _.get(dod, "day[0]._", "");
  let dodMonth = _.get(dod, "month[0]._", "");
  let dodYear = _.get(dod, "year[0]._", "");
  let tokens = [];
  if (dodStr !== "") {
    tokens = dodStr.split("/");
  }
  if (tokens.length === 1) {
    if (dodYear === "") {
      dodYear = tokens[0];
    }
  } else {
    if (dodDay === "" && tokens.length > 1) {
      dodDay = tokens[1];
    }
    if (dodMonth === "" && tokens.length > 0) {
      dodMonth = tokens[0];
    }
    if (dodYear === "" && tokens.length > 2) {
      dodYear = tokens[2];
    }
  }
  if (props.userAccount.btType === "3") {
    if (dodYear !== "") {
      if (dodMonth !== "") {
        return `${dodMonth}/${dodYear}`;
      }
      return dodYear;
    }
    return "N/A";
  }

  if (dodDay !== "") return `${dodMonth}/${dodDay}/${dodYear}`;
  if (dodMonth !== "") return `${dodDay}/${dodYear}`;
  if (dodYear !== "") return dodYear;

  return "N/A";
};



// WEBPACK FOOTER //
// ./src/components/common/DisplayDate.js